import React, {FormEvent, useState} from 'react';
import styled from 'styled-components';
import {TextInput} from './form/TextInput';
import {RadioInput} from './form/RadioInput';
import {CheckboxInput} from './form/CheckboxInput';
import {Food} from './Food';
import {Movement} from './Movement';
import {climb_stairs, cycle, hoover, jog, walk} from '../config/met';

const CalculatorDiv = styled.div`
    .label {
        display: block;
        margin-bottom: 10px;
    }
    .step__text {
        margin-bottom: 35px;
    }
    button {
        margin-bottom: 100px;
        &:before {
            content: '';
            width: 100vW;
            right: -100vW;
            position: absolute;
            height: 100%;
            display: block;
            top: 0;
            background: #AEC90A;
        }
        &:hover {
            &:before {
                background: #C1C98F;
            }
        }
    }
    .add-margin {
        margin-bottom: 50px;
    }
    .triangle {
        min-height: 795px;
    }
    @media screen and (max-width: 768px) {
        .hide-for-small {
            display: none !important;
        }
    }
    .ppi_row__centered {
        display: flex;
        align-items: center;
    }
    .downloads {
        &:before {
            background: none;
        }
        display: block;
        .downloads__items {
            .downloads__item {
                color: #000;
                &:hover {
                    color: #000;
                }
                &:before {
                    color: #AEC90A;
                }
            }
        }
    }
    .ppi_column_container__right {
        text-align: right;
    }
    .lifestyle-container {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ccc;
        margin: 20px 0;
        padding-bottom: 20px;
        &__radios {
            label {
                margin-bottom: 30px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            align-self: center;
        }
        &__description {
            padding: 0 30px;
            small {
                display: block;
                color: #777;
                font-size: 16px;
            }
        }
        &:last-child {
            border-bottom: none;
            margin: 0;
        }
    }
    .no-margin {
        margin: 0 !important;
    }
`;
const ResultsDiv = styled.div``;

export function Calculator() {

    const [showResults, setShowResults] = useState(false);

    const [gender, setGender] = useState('m');
    const [lifestyle, setLifestyle] = useState('active-1');
    const [age, setAge] = useState('');
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [sport, setSport] = useState(false);

    const [reuKj, setReuKj] = useState(0);
    const [reuKcal, setReuKcal] = useState(0);
    const [geuKj, setGeuKj] = useState(0);
    const [geuKcal, setGeuKcal] = useState(0);
    const [leuKj, setLeuKj] = useState(0);
    const [leuKcal, setLeuKcal] = useState(0);

    const [foodActive, setFoodActive] = useState('Zucker');
    const [errors, setErrors] = useState({age: false, height: false, weight: false});

    const refresh = () => {
        window.location.href = window.location.href.split('#')[0];
    }

    const handleTextInputChange = (name: string, value: string) => {
        const regexp = /^[1-9][0-9]{0,2}$/ as RegExp;
        (name === 'age' && (regexp.test(value) || value === '')) ? setAge(value) : setAge(age);
        (name === 'weight' && (regexp.test(value) || value === '')) ? setWeight(value) : setWeight(weight);
        (name === 'height' && (regexp.test(value) || value === '')) ? setHeight(value) : setHeight(height);
    }

    const handleSportChange = (checked: boolean) => {
        setSport(checked);
    }

    const handleGenderChange = (value: string) => {
        setGender(value);
    }

    const handleLifestyleChange = (value: string) => {
        setLifestyle(value);
    }

    const handleCalculateTurnover = (e: FormEvent) => {
        e.preventDefault();
        calculateTurnover();
        let isValid = validateFields();
        if(isValid) {
            setShowResults(true);
        }
    }

    const validateFields = () => {
        setErrors({age: age === '', weight: weight === '', height: height === ''});
        return age !== '' && weight !== '' && height !== '';
    }

    const calculateTurnover = () => {

        let reu;
        const age_int = parseInt(age);
        const weight_int = parseInt(weight);
        const height_int = parseFloat(height) / 100;
        const factor_kcal = 0.239;

        // man
        //////////////////

        if(gender === 'm') {
            // 1 - 3
            if(age && 1 <= age_int && age_int < 3) {
                reu = 1000 * ((0.118 * weight_int) + (3.59 * height_int) - 1.55);
            }

            // 3 - 11
            if(age && 3 <= age_int && age_int < 11) {
                reu = 1000 * ((0.0632 * weight_int) + (1.31 * height_int) + 1.28);
            }

            // 11 - 19
            if(age && 11 <= age_int && age_int < 19) {
                reu = 1000 * ((0.0651 * weight_int) + (1.11 * height_int) + 1.25);
            }

            // 19+
            if(age && age_int >= 19) {
                reu = 1000 * ((0.047 * weight_int) + 1.009 - (0.01452 * age_int) + 3.21);
            }
        }

        // woman
        ///////////////

        if(gender === 'f') {
            // 1 - 3
            if(age && 1 <= age_int && age_int <= 3) {
                reu = 1000 * ((0.127 * weight_int) + (2.94 * height_int) - 1.20);
            }

            // 3 - 11
            if(age && 3 <= age_int && age_int < 11) {
                reu = 1000 * ((0.0666 * weight_int) + (0.878 * height_int) + 1.46);
            }

            // 11 - 19
            if(age && 11 <= age_int && age_int < 19) {
                reu = 1000 * ((0.0393 * weight_int) + (1.04 * height_int) + 1.93);
            }

            // 19+
            if(age && age_int >= 19) {
                reu = 1000 * ((0.047 * weight_int) - (0.01452 * age_int) + 3.21);
            }
        }

        if(reu) {
            setReuKj(Math.round(reu));
            setReuKcal(Math.round(reu * factor_kcal));
            const pal: number|boolean = getPAL();
            if(pal && reu) {
                let geu;
                geu = reu * (pal + (sport ? 0.3 : 0));
                setGeuKj(Math.round(geu));
                setGeuKcal(Math.round(geu * factor_kcal));
                if(reu && geu) {
                    setLeuKj(Math.round(geu - reu));
                    setLeuKcal(Math.round((geu - reu) * factor_kcal));
                }
            }
        }

        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const scroll_to_motion_section = () => {
        let el = document.getElementById('bewegungsform');
        if(el !== null) {
            let rect = el.getBoundingClientRect(),
                scrollTop = window.scrollY || document.documentElement.scrollTop;
            window.scrollTo({top: rect.top + scrollTop, behavior: 'smooth'});
        }
    }

    const handleFoodClick = (clickedFood: string) => {
        setFoodActive(clickedFood);
        let target = document.getElementById('bewegungsform');
        if(target !== null) {
            scroll_to_motion_section();
        }
    }

    const getPAL = () => {
        switch (lifestyle) {
            case 'lying-1':
                return 1.2;
            case 'lying-2':
                return 1.3;
            case 'sitting-1':
                return 1.4;
            case 'sitting-2':
                return 1.5;
            case 'moderate-1':
                return 1.6;
            case 'moderate-2':
                return 1.7;
            case 'active-1':
                return 1.8;
            case 'active-2':
                return 1.9;
            case 'heavy-1':
                return 2;
            case 'heavy-2':
                return 2.1;
            case 'heavy-3':
                return 2.2;
            case 'heavy-4':
                return 2.3;
            case 'heavy-5':
                return 2.4;
            default:
                return false;
        }
    }

    const get_kcal = (): number => {
        switch (foodActive) {
            case 'Zucker':
                return 24;
            case 'Orangensaft':
                return 86;
            case 'Schokolade':
                return 107;
            case 'Banane':
                return 88;
            case 'Joghurt':
                return 105;
            case 'Gummibärchen':
                return 70;
            case 'Honig':
                return 60;
            case 'Pizza':
                return 746;
            case 'Brot':
                return 100;
            default:
                return 0;
        }
    }

    const calculate_time_to_burn_energy = (met: number) => {
        return Math.round((get_kcal() * 60) / (met * parseInt(weight)));
    }

    // 3min of activity is approximately 1% in progress bar
    const get_percent = (met: number) => {
        let factor = foodActive === 'Pizza' ? 4 : 1;
        let result = (Math.round((get_kcal() * 60) / (met * parseInt(weight)))) / factor;
        return result > 95 ? 95 : result;
    }

    return (
        <CalculatorDiv className={'content content--page'}>
            <div className="ppi_row">
                <div className="ppi_col-md-10 ppi_col-md-offset-1 ppi_col-lg-8 ppi_col-lg-offset-2">
                    <div className="content__container">
                        {!showResults && <form onSubmit={handleCalculateTurnover} noValidate>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <h2>Schritt 1</h2>
                                    <p className={"step__text"}>
                                        Geben Sie bitte hier Ihr Geschlecht, Alter, Gewicht und ggf. Ihre Körpergröße an.
                                        Um die Berechnung zu starten, müssen alle Felder ausgefüllt sein.
                                    </p>
                                    <span className={"label"}><strong>Geschlecht*</strong></span>
                                    <RadioInput
                                        required
                                        value='m'
                                        name='gender'
                                        checked={gender === 'm'}
                                        onChange={handleGenderChange}
                                        class={'gender'}
                                    >männlich</RadioInput>
                                    <RadioInput
                                        value='f'
                                        name='gender'
                                        checked={gender === 'f'}
                                        onChange={handleGenderChange}
                                        class={'gender'}
                                    >weiblich</RadioInput><br/><br/>
                                    <div className="ppi_row">
                                        <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-4">
                                            <TextInput
                                                label='Alter'
                                                placeholder='Jahre'
                                                required
                                                name='age'
                                                value={age}
                                                onChange={handleTextInputChange}
                                                invalid={errors.age}
                                            />
                                        </div>
                                        <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-4">
                                            <TextInput
                                                label='Körpergewicht (in kg)'
                                                placeholder='Kilogramm'
                                                required
                                                name='weight'
                                                value={weight}
                                                onChange={handleTextInputChange}
                                                invalid={errors.weight}
                                            />
                                        </div>
                                        <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-4">
                                            <TextInput
                                                label='Körpergröße (in cm)'
                                                placeholder='Zentimeter'
                                                required
                                                name='height'
                                                value={height}
                                                onChange={handleTextInputChange}
                                                invalid={errors.height}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <h2>Schritt 2</h2>
                                    <p className={"step__text"}>
                                        Bitte wählen Sie anhand der Skala, wie aktiv Ihr Lebensstil im Durchschnitt ist.
                                        Überlegen Sie bitte möglichst genau. Zu den verschiedenen Einstellungen werden unten jeweils Beschreibungen eingeblendet.
                                    </p>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <p><strong>Mein Lebensstil*</strong></p>
                                </div>
                            </div>
                            <div className="ppi_row  add-margin">
                                <div className="ppi_column_container hide-for-small ppi_col-md-2">
                                    <img className={'triangle'} src={process.env.PUBLIC_URL + '/images/dreieck.svg'} alt={'triangle'} />
                                </div>
                                <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-10">
                                    <div className="lifestyle-container">
                                        <div className="lifestyle-container__radios">
                                            <RadioInput
                                                required
                                                value='heavy-5'
                                                name='lifestyle'
                                                checked={lifestyle === 'heavy-5'}
                                                onChange={handleLifestyleChange}
                                            >13</RadioInput>
                                            <RadioInput
                                                required
                                                value='heavy-4'
                                                name='lifestyle'
                                                checked={lifestyle === 'heavy-4'}
                                                onChange={handleLifestyleChange}
                                            >12</RadioInput>
                                            <RadioInput
                                                required
                                                value='heavy-3'
                                                name='lifestyle'
                                                checked={lifestyle === 'heavy-3'}
                                                onChange={handleLifestyleChange}
                                            >11</RadioInput>
                                            <RadioInput
                                                required
                                                value='heavy-2'
                                                name='lifestyle'
                                                checked={lifestyle === 'heavy-2'}
                                                onChange={handleLifestyleChange}
                                            >10</RadioInput>
                                            <RadioInput
                                                required
                                                value='heavy-1'
                                                name='lifestyle'
                                                checked={lifestyle === 'heavy-1'}
                                                onChange={handleLifestyleChange}
                                            >9</RadioInput>
                                        </div>
                                        <div className="lifestyle-container__description">
                                            Körperlich anstrengende berufliche Arbeit oder sehr aktive Freizeittätigkeit
                                            <small>(z. B. Bauarbeiter, Landwirte, Waldarbeiter, Bergarbeiter, Leistungssportler)</small>
                                        </div>
                                    </div>
                                    <div className="lifestyle-container">
                                        <div className="lifestyle-container__radios">
                                            <RadioInput
                                                value='active-2'
                                                name='lifestyle'
                                                checked={lifestyle === 'active-2'}
                                                onChange={handleLifestyleChange}
                                            >8</RadioInput>
                                            <RadioInput
                                                value='active-1'
                                                name='lifestyle'
                                                checked={lifestyle === 'active-1'}
                                                onChange={handleLifestyleChange}
                                            >7</RadioInput>
                                        </div>
                                        <div className="lifestyle-container__description">
                                            Überwiegend gehende und stehende Arbeit
                                            <small>(z. B. Verkäufer, Kellner, Mechaniker, Handwerker)</small>
                                        </div>
                                    </div>
                                    <div className="lifestyle-container">
                                        <div className="lifestyle-container__radios">
                                            <RadioInput
                                                value='moderate-2'
                                                name='lifestyle'
                                                checked={lifestyle === 'moderate-2'}
                                                onChange={handleLifestyleChange}
                                            >6</RadioInput>
                                            <RadioInput
                                                value='moderate-1'
                                                name='lifestyle'
                                                checked={lifestyle === 'moderate-1'}
                                                onChange={handleLifestyleChange}
                                            >5</RadioInput>
                                        </div>
                                        <div className="lifestyle-container__description">
                                            Sitzende Tätigkeit, zeitweilig auch zusätzlicher Energieaufwand für gehende und stehende Tätigkeiten, wenig oder keine anstrengende Freizeitaktivität
                                            <small>(z. B. Laboranten, Studenten, Fließbandarbeiter)</small>
                                        </div>
                                    </div>
                                    <div className="lifestyle-container">
                                        <div className="lifestyle-container__radios">
                                            <RadioInput
                                                value='sitting-2'
                                                name='lifestyle'
                                                checked={lifestyle === 'sitting-2'}
                                                onChange={handleLifestyleChange}
                                            >4</RadioInput>
                                            <RadioInput
                                                value='sitting-1'
                                                name='lifestyle'
                                                checked={lifestyle === 'sitting-1'}
                                                onChange={handleLifestyleChange}
                                            >3</RadioInput>
                                        </div>
                                        <div className="lifestyle-container__description">
                                            Ausschließlich sitzende Tätigkeit mit wenig oder keiner anstrengenden Freizeitaktivität
                                            <small>(z. B. Büroangestellte , Feinmechaniker)</small>
                                        </div>
                                    </div>
                                    <div className="lifestyle-container">
                                        <div className="lifestyle-container__radios">
                                            <RadioInput
                                                value='lying-2'
                                                name='lifestyle'
                                                checked={lifestyle === 'lying-2'}
                                                onChange={handleLifestyleChange}
                                            >2</RadioInput>
                                            <RadioInput
                                                value='lying-1'
                                                name='lifestyle'
                                                checked={lifestyle === 'lying-1'}
                                                onChange={handleLifestyleChange}
                                            >1</RadioInput>
                                        </div>
                                        <div className="lifestyle-container__description">
                                            Ausschließlich liegende oder sitzende Lebensweise
                                            <small>(z. B. bettlägerige, gebrechliche, immobile Menschen)</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ppi_row ppi_row__centered">
                                <div className="ppi_column_container ppi_col-md-2 hide-for-small">
                                    <img src={process.env.PUBLIC_URL + '/images/zuckermann.png'} alt={'Sporty'} />
                                </div>
                                <div className="ppi_column_container ppi_col-md-10">
                                    <CheckboxInput
                                        checked={sport}
                                        onChange={handleSportChange}
                                    >Pro Woche betätige ich mich 4 bis 5 Mal ca. 30 bis 60 Minuten beim Sport/einer anstrengenden Freizeitbeschäftigung.</CheckboxInput>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_column_container__right ppi_col-sm-12">
                                    <button type={'submit'} className={'calculate_turnover button button--schmeckt-richtig'}>Jetzt berechnen</button>
                                </div>
                            </div>
                        </form>}
                        {showResults && <ResultsDiv>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-md-12">
                                    <h2>Auswertung</h2>
                                    <p>Ihr durchschnittlicher Energiebedarf (grob).</p>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-4">
                                    <p><strong>Ruheenergieumsatz:</strong></p>
                                    <p>{reuKcal} kcal bzw. {reuKj} kj</p>
                                </div>
                                <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-4">
                                    <p><strong>Leistungsenergieumsatz:</strong></p>
                                    <p>{leuKcal} kcal bzw. {leuKj} kj</p>
                                </div>
                                <div className="ppi_column_container ppi_col-sm-12 ppi_col-md-4">
                                    <p><strong>Gesamtenergieumsatz:</strong></p>
                                    <p className={'no-margin'}>{geuKcal} kcal bzw. {geuKj} kj</p>
                                    <small>(So viele Kalorien verbraucht mein Körper am Tag grob.)</small>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <h4>Nahrungsmittel</h4>
                                    <p>Klicken Sie auf eines der Lebensmittel, um herauszufinden, wie lange und welche Art von Bewegung nötig ist, um die aufgenommene Energie vollständig umzusetzen.</p>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <Food src={process.env.PUBLIC_URL + "/images/zucker.png"} alt={"Zucker"} caption={"(1 TL, 6g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/orangensaft.png"} alt={"Orangensaft"} caption={"(1 Glas frisch gepresst, 200g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/schokolade.png"} alt={"Schokolade"} caption={"(20g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/banane.png"} alt={"Banane"} caption={"(1 Stk., 100g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/gummi.png"} alt={"Gummibärchen"} caption={"(10 Stk., 20g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/honig.png"} alt={"Honig"} caption={"(20g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/pizza.png"} alt={"Pizza"} caption={"(1 Stk., 375g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/brot.png"} alt={"Brot"} caption={"(1 Scheibe ohne Belag, 50g)"} active={foodActive} onClick={handleFoodClick}/>
                                <Food src={process.env.PUBLIC_URL + "/images/joghurt.png"} alt={"Joghurt"} caption={"(1 Becher, 3,5% Fett, 150g)"} active={foodActive} onClick={handleFoodClick}/>
                            </div>
                            <div id="bewegungsform" className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <h4>Bewegungsform</h4>
                                </div>
                            </div><br/><br/>
                            <div className="ppi_row">
                                <Movement percent={get_percent(hoover)} src={process.env.PUBLIC_URL + "/icons/icon-staubsaugen.png"} alt={"Staubsaugen"} duration={calculate_time_to_burn_energy(hoover)}/>
                                <Movement percent={get_percent(jog)} src={process.env.PUBLIC_URL + "/icons/icon-laufen.png"} alt={"Laufen"} duration={calculate_time_to_burn_energy(jog)}/>
                                <Movement percent={get_percent(cycle)} src={process.env.PUBLIC_URL + "/icons/icon-radfahren.png"} alt={"Radfahren"} duration={calculate_time_to_burn_energy(cycle)}/>
                                <Movement percent={get_percent(climb_stairs)} src={process.env.PUBLIC_URL + "/icons/icon-treppensteigen.png"} alt={"Treppensteigen"} duration={calculate_time_to_burn_energy(climb_stairs)}/>
                                <Movement percent={get_percent(walk)} src={process.env.PUBLIC_URL + "/icons/icon-gehen.png"} alt={"Gehen"} duration={calculate_time_to_burn_energy(walk)}/>
                            </div>
                            <br/><br/>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <h4>Weiterführende Informationen</h4>
                                </div>
                            </div>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12 downloads">
                                    <div className="downloads__items">
                                        <p>Pocketguide: Lesen Sie hier mehr zum Energieumsatz.</p>
                                        <a className={'downloads__item'} href={process.env.PUBLIC_URL + '/pdf/Pocketguide.pdf'} rel="noreferrer" target={'_blank'}><strong>Pocketguide herunterladen</strong></a>
                                    </div>
                                </div>
                            </div><br/><br/>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12 downloads">
                                    <div className="downloads__items">
                                        <p>Zucker & Körpergewicht: Mehr Informationen zu Zucker und Körpergewicht erhalten Sie hier.</p>
                                        <a className={'downloads__item'} href={process.env.PUBLIC_URL + '/pdf/Schmeckt_Richtig_Broschuere-2020_Zucker-und-Koerpergewicht.pdf'} rel="noreferrer" target={'_blank'}><strong>Broschüre herunterladen</strong></a>
                                    </div>
                                </div>
                            </div><br/><br/>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <h4>Der Energiebedarfsrechner</h4>
                                    <p>
                                        Der Energiebedarf eines Menschen ist individuell verschieden und von vielen Faktoren abhängig. Etwa der Muskelmasse, dem Bewegungsverhalten in Beruf und Freizeit oder der Umgebungstemperatur.
                                        Der Energiebedarfsrechner basiert auf den DACH-Referenzwerten für die Nährstoffzufuhr der Empfehlungen der Deutschen Gesellschaft für Ernährung (DGE), der Österreichischen Gesellschaft für Ernährung
                                        (ÖGE) und der Schweizerischen Gesellschaft für Ernährung (SGE) und liefert einen groben Näherungswert zur Orientierung. Der individuelle Energiebedarf wird sowohl in Kilokalorien (kcal) als auch in
                                        Kilojoule (kJ) ausgegeben.
                                    </p>
                                    <p>
                                        Der Ruheenergieumsatz (auch „Ruheenergieverbrauch“) wird entsprechend den DACH-Referenzwerten für die Nährstoffzufuhr (vgl. DGE et al. 2015) stellvertretend für den Grundumsatz angegeben.
                                        Damit wird die Energiemenge beschrieben, die der Körper im Ruhezustand zum Erhalt grundlegender Lebensfunktionen benötigt. Der Ruheenergieumsatz liegt im Schnitt etwa 10 % über dem Grundumsatz,
                                        weil er unter weniger strengen „Ruhekriterien“ gemessen wird. Der hier ausgegebene Wert wird entsprechend der DACH-Referenzwerte für Kinder und Jugendliche unter 19 Jahren nach Henry (2005) und
                                        für Erwachsene ab 19 Jahren nach Müller et al. (2004) berechnet.
                                    </p>
                                    <p>
                                        Der Leistungsenergieumsatz gibt an, wie viel Energie zusätzlich zum Ruheenergieumsatz benötigt wird. Er variiert deutlich je nach Grad der Aktivität: Menschen, die einer schweren körperlichen
                                        Arbeit nachgehen oder Sport mit einer hohen Belastung betreiben, haben einen höheren Energiebedarf als Menschen, die sich in Beruf und Freizeit körperlich wenig anstrengen.
                                        Da der Leistungsenergieumsatz nicht direkt gemessen werden kann, berechnet man diesen aus der Differenz des Gesamtenergieumsatzes und des Ruheenergieumsatzes, das heißt:
                                    </p>
                                    <p>
                                        <strong>„Leistungsenergieumsatz = Gesamtenergieumsatz – Ruheenergieumsatz“</strong>
                                    </p>
                                    <p>
                                        Der Gesamtenergieumsatz gibt den gesamten Energiebedarf eines Menschen an. Dieser sollte mit der Nahrung zugeführt werden. Nimmt man auf Dauer weniger als diese Menge an Energie zu sich, führt
                                        dies in der Regel zur Gewichtsabnahme. Nimmt man über einen längeren Zeitraum mehr als diese Energiemenge mit der Nahrung auf, erhöht sich für gewöhnlich das Körpergewicht.
                                        Die überschüssige, das heißt nicht umgesetzte, Energiemenge wird dabei in Form von Speicherfett im Körper eingelagert. Der Gesamtenergieumsatz wird hier mittels sogenannter PAL-Werte
                                        (PAL = Physical Activity Level; Maß für die körperliche Aktivität) berechnet. Dabei wird der individuelle Ruheenergieumsatz mit einem für den jeweiligen Lebensstil passenden Faktor multipliziert.
                                        Ein Lebensstil mit wenig Bewegung hat demnach einen geringen Faktor, d. h. PAL-Wert, als ein Lebensstil mit viel Bewegung. Bitte berücksichtigen Sie, dass schwangere und stillende Frauen in der
                                        Regel einen erhöhten Energiebedarf haben, der durch diesen Rechner nicht berücksichtigt wird.
                                    </p>
                                    <p>
                                        Die Zeit, die man benötigt, um die in einem Lebensmittel enthaltene Energie umzusetzen, wird hier mittels der MET-Methode ermittelt (MET = Metabolic Equivalent of Task; Metabolisches Äquivalent).
                                        Bei dieser Methode wird der Sauerstoffbedarf normalgewichtiger Personen bei verschiedenen Aktivitäten gemessen und so deren Energieumsatz ermittelt. Jeder Art von Aktivität ist somit ein anderer
                                        MET-Wert zugeordnet. Die MET-Werte lassen sich zum Beispiel dem „Compendium of Physical Activities“ entnehmen (vgl. Ainsworth et al. 2011).
                                    </p>
                                    <p>
                                        Die jeweils berechneten Werte dienen nur zu Ihrer groben Orientierung. Zur genauen Bestimmung Ihres persönlichen Energiebedarfs wenden Sie sich bitte an Ihren Arzt oder einen Ernährungsberater.
                                    </p>
                                </div>
                            </div>
                            <br/><br/>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_col-sm-12">
                                    <div className="vc_tta-container" data-vc-action="collapseAll">
                                        <div className="vc_general vc_tta vc_tta-accordion vc_tta-color-grey vc_tta-style-classic vc_tta-shape-rounded vc_tta-o-shape-group vc_tta-controls-align-left vc_tta-o-all-clickable">
                                            <div className="vc_tta-panels-container">
                                                <div className="vc_tta-panels">
                                                    <div className="vc_tta-panel" id="1624516794590-9ed15122-df92" data-vc-content=".vc_tta-panel-body">
                                                        <div className="vc_tta-panel-heading">
                                                            <h4 className="vc_tta-panel-title vc_tta-controls-icon-position-left">
                                                                <a href="#1624516794590-9ed15122-df92" data-vc-accordion="" data-vc-container=".vc_tta-container">
                                                                    <span className="vc_tta-title-text">Quellen</span>
                                                                    <i className="vc_tta-controls-icon vc_tta-controls-icon-plus"></i>
                                                                </a>
                                                            </h4>
                                                        </div>
                                                        <div className="vc_tta-panel-body">
                                                            <div className="wpb_text_column wpb_content_element ">
                                                                <div className="wpb_wrapper">
                                                                    <p>
                                                                        Ainsworth BE, Haskell WL, Herrmann SD, Meckes N, Bassett Jr DR, Tudor-Locke C, Greer JL, Vezina J, Whitt-Glover MC, Leon AS (2011):
                                                                        Compendium of Physical Activities. A second update of codes and MET values. Medicine and Science in Sports and Exercise.
                                                                        <br/><br/>
                                                                        <a href={"https://sites.google.com/site/compendiumofphysicalactivities"} target={"_blank"} rel="noreferrer">https://sites.google.com/site/compendiumofphysicalactivities</a><br/>
                                                                        (Stand: 31-OCT-2015)
                                                                    </p>
                                                                    <p>
                                                                        Deutsche Gesellschaft für Ernährung, Österreichische Gesellschaft für Ernährung, Schweizerische Gesellschaft für Ernährungsforschung,
                                                                        Schweizerische Vereinigung für Ernährung (Hrsg.)(2015): Referenzwerte für die Nährstoffzufuhr. Bonn, 2. Auflage, 1. Ausgabe
                                                                    </p>
                                                                    <p>
                                                                        Henry CJ (2005): Basal metabolic rate studies in humans. Measurement and development of new equations. In: Public Health Nutrition 8(7A); S. 1133–1152
                                                                    </p>
                                                                    <p>
                                                                        Müller MJ, Bosy-Westphal A, Klaus S, Kreymann G, Lührmann PM, Neuhäuser-Berthold M, Noack R, Pirke KM, Platte P, Selberg O, Steininger J (2004):
                                                                        World Health Organization equations have shortcomings for predicting resting energy expenditure in persons from a modern, affluent population.
                                                                        Generation of a new reference standard from a retrospective analysis of a German database of resting energy expenditure.
                                                                        In: Am J Clin Nutr 2004 (80); S. 1379-1390
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br/><br/>
                            <div className="ppi_row">
                                <div className="ppi_column_container ppi_column_container__right ppi_col-sm-12">
                                    <button className={'button button--schmeckt-richtig'} onClick={refresh}>Rechner neu starten</button>
                                </div>
                            </div>
                        </ResultsDiv>}
                    </div>
                </div>
            </div>
        </CalculatorDiv>
    );
}
